import CustomFormInput from 'components/input/custom-form-input/CustomFormInput'
import { useTranslation } from 'react-i18next'
import { FORM, PLACEHOLDERS } from 'locales/locales'
import styled from 'styled-components'
import { emailValidation, requiredValidation } from 'utils/helpers/validations'
import { FixMeLater, IDropdownOption } from 'types'
import Checkbox from 'components/checkbox/Checkbox'
import CustomText from 'components/text/CustomText'
import DropdownListWithSearch from 'components/kendo/dropdown/DropdownListWithSearch'
import { Chip } from '@progress/kendo-react-buttons'
import colors from 'utils/colors'
import { useEffect, useState } from 'react'

interface IAddUserProps {
  formChecked: boolean
  fullname: string
  email: string
  title: string
  isVerify: boolean
  dropDownData?: { teams?: Array<FixMeLater>; roles?: Array<FixMeLater> }
  setDropDownData: React.Dispatch<React.SetStateAction<{ teams?: Array<FixMeLater>; roles?: Array<FixMeLater> }>>
  selectedOptions: {
    roleId: Array<{ title: string; value: string }>
    teamId: Array<{ title: string; value: string }>
  }
  onChangeInput: (value: string, key: string) => void
  onChangeCheckbox: (value: boolean) => void
  // NewsfeedTeamManagement.tsx'den alınan dropdown search props'ları
  setDropdownDataState: (filter: FixMeLater) => void
  handleDropdownSearch: (skip: number, filter: string) => Promise<{ data: FixMeLater[]; total: number }>
}

const CreateUserForm = ({
  formChecked,
  fullname,
  email,
  title,
  isVerify,
  dropDownData,
  selectedOptions ,
  onChangeInput,
  onChangeCheckbox,
  setDropdownDataState,
  handleDropdownSearch,
  setDropDownData,
}: IAddUserProps) => {
  const { t } = useTranslation()

  const [selectedTeam, setSelectedTeam] = useState(selectedOptions.teamId)

  useEffect(() => {
    onChangeInput(selectedTeam as any, 'teamId')
  }, [selectedTeam])

  return (
    <Wrapper>
      <CustomFormInput
        errorText={formChecked ? requiredValidation(fullname, t(FORM.FULLNAME)).errorText : ''}
        type={'text'}
        title={t(FORM.FULLNAME)}
        placeholder={t(PLACEHOLDERS.FULLNAME)}
        value={fullname}
        onChange={(value: string) => onChangeInput(value, 'fullname')}
      />
      <CustomFormInput
        errorText={formChecked ? emailValidation(email).errorText : ''}
        type={'text'}
        title={t(FORM.EMAIL)}
        placeholder={t(PLACEHOLDERS.EMAIL)}
        value={email}
        onChange={(value: string) => onChangeInput(value, 'email')}
      />
      <CustomFormInput
        type={'text'}
        title={t(FORM.TITLE)}
        placeholder={t(PLACEHOLDERS.TITLE)}
        value={title}
        onChange={(value: string) => onChangeInput(value, 'title')}
      />
      <FormFieldWrapper>
        <CustomText typography="header3">{t(FORM.TEAM)}</CustomText>
        <StyledDropDownListWithSearch
          selectedOption={
            selectedTeam?.length > 0
              ? selectedTeam[selectedTeam.length - 1]
              : ({ title: t(FORM.TEAM_SELECT), value: null } as IDropdownOption)
          }
          options={
            dropDownData?.teams?.filter(
              (team: any) => !selectedTeam.some((t: any) => t.value === team.value),
            ) || []
          }
          onChangeOption={(option: IDropdownOption) => {
            setSelectedTeam((prevState) => [...prevState, option] as FixMeLater)
          }}
          setFilterDataState={setDropdownDataState}
          setDropdownData={(data: FixMeLater) => {
            setDropDownData((prevState: FixMeLater) => ({ ...prevState, teams: data }))
          }}
          filterDataState={undefined}
          /* defaultItem={{ title: t(PLACEHOLDERS.TEAM_PLACEHOLDER) }} */
          requestData={handleDropdownSearch}
          style={{ width: '100%' }}
        />
      </FormFieldWrapper>
      {selectedTeam?.length > 0 && (
        <MultipleSearchWrapper>
          {selectedTeam?.map((team: any, index: number) => {
            return (
              <ChipWrapper
                key={team.value + index}
                text={team.title}
                value={team.value}
                removable={true}
                size={'small'}
                themeColor={'info'}
                fillMode={'solid'}
                disabled={false}
                onRemove={() =>
                  setSelectedTeam(selectedTeam.filter((t: any) => t.value !== team.value))
                }
              />
            )
          })}
        </MultipleSearchWrapper>
      )}
      <CustomFormInput
        type={'text'}
        dropdownType="MultiSelect"
        title={t(FORM.USER_ROLE)}
        dropDownData={dropDownData?.roles}
        selectedOption={selectedOptions.roleId}
        onChange={(value: string) => onChangeInput(value, 'roleId')}
      />
      <CheckboxWrapper>
        <Checkbox checked={isVerify} onChange={onChangeCheckbox} />
        <CustomText typography="body6">{t(PLACEHOLDERS.ISVERIFY)}</CustomText>
      </CheckboxWrapper>
    </Wrapper>
  )
}

export default CreateUserForm

const Wrapper = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  overflow: visible;
  &::-webkit-scrollbar {
    display: none;
  }
`
const ChipWrapper = styled(Chip)`
  background-color: ${colors.vime20};
  .k-chip-label,
  .k-chip-text {
    padding: 1px 3px;
  }
`
const MultipleSearchWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
  row-gap: 3px;
  margin-left: 5px;
  margin-bottom: 20px;
`

const CheckboxWrapper = styled.div`
  display: flex;
  width:100%;
  justify-content: end;
  column-gap: 4px;
  margin-top:8px;
  margin-bottom: 10px;
  align-items: center;
`

const FormFieldWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`

const StyledDropDownListWithSearch = styled(DropdownListWithSearch)`
  width: 100%;
  border-radius: 4px;

  .k-picker {
    border: 1px solid #ddd;
    height: 40px;
  }

  .k-input-inner {
    padding: 0.5rem;
    font-size: 14px;
  }

  &:focus {
    outline: 2px solid #90caf9;
    outline-offset: 2px;
  }
`